import React, { useEffect, useRef } from 'react';
import { dataLoadingRequest } from '../../ducks/loadingData';
import {configSelector, downloadDocumentRequest, uploadConfigRequest, uploadFileRequest} from '../../ducks/documents';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Form, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Button from 'semantic-ui-react/dist/commonjs/elements/Button';

const File = ({
    value,
    name,
    onChange,
    onBlur,
    isDisabled,
    hintKey,
    noLabel,
    className,
    text,
    error,
    type,
    datalist: valuesList = [],
    placeholder,
    isRequired,
    autoComplete,
    autoFocus,
    isGrid,
}) => {
    const { t } = useTranslation();
    const fileUploader = useRef(null);
    const dispatch = useDispatch();
    
    const config = useSelector(state => configSelector(state));

    useEffect(() => {
        if (!config || !config.maxSizeBytes) {
            dispatch(uploadConfigRequest());
        }
    }, []);

    const onFilePicked = e => {
        let form = new FormData();
        let file = e.target.files[0];
        form.append('formFile', file);
        if (file.size <= config.maxSizeBytes) {
            dispatch(
                uploadFileRequest({
                    form,
                    callbackSuccess: id => {
                        onChange(e, {
                            name,
                            value: {
                                value: id,
                                name: file.name,
                            },
                        });
                    },
                }),
            );
            fileUploader.current.value = null;
        } else {
            toast.error(t('Files.maxFileSize').replace('{0}', config.maxSizeName), {
                autoClose: false,
            });
        }

       
    };

    const handleDownload = () => {
        value && value.value && dispatch(downloadDocumentRequest({
            id: value.value
        }))
    };

    console.log(error);

    return (
        <Form.Field>
            {!noLabel ? (
                <label className={isDisabled ? 'label-disabled' : null}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: `${t(text || name)}${isRequired ? ' *' : ''}`,
                        }}
                    />
                </label>
            ) : null}
            <div className={error === undefined ? "field-file": "field-file field-file_error"}>
                <div
                    className={error === undefined ? "field-file_link": "field-file_link field-file_link-error"}
                    onClick={handleDownload}
                >
                    {value && typeof value === 'object' ? value.name : value}
                </div>
                <Button
                    disabled={isDisabled}
                    icon
                    onClick={() => {
                        fileUploader && fileUploader.current.click();
                    }}
                >
                    <Icon name="upload" />
                </Button>
            </div>
            <input
                type="file"
                ref={fileUploader}
                style={{ display: 'none' }}
                onChange={onFilePicked}
            />
            { hintKey && <span className="label-hint">{t(hintKey)}</span> }
            { hintKey && error !== undefined && <br/> }
            { error !== undefined ? <span className="label-error">{error}</span> : ""}
        </Form.Field>
    );
};

export default File;
